export default (set, get, choiceId, choiceMetadata) => set(
  () => ({
    configurator: {
      ...get().configurator,
      metadata: {
        ...get().configurator.metadata,
        [choiceId]: {
          ...get().configurator.metadata[choiceId],
          metadata: choiceMetadata
        }
      }
    }
  }),
  false,
  { type: 'configurator/updateConfiguratorMetadata', choiceId }
);
